import React, { useEffect, useState } from 'react'
import NavigationBar from '../components/NavigationBar'
import { MDBAlert, MDBCol, MDBContainer, MDBRadio, MDBRow, MDBSelect } from 'mdb-react-ui-kit'
import LandingFooter from '../components/LandingFooter'
import RelatedProducts from '../components/RelatedProducts'
import ContactUs from '../components/ContactUs'
import { useNavigate } from 'react-router'
import { landingpagePricingPlans } from '../../motos_lp/component/pricingplans'
import { CreateVistorInfo, getAllPricingPlans, } from '../../services/apiServices'
import { MDBBtn, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle } from "mdb-react-ui-kit";
import { isEmail } from '../../validators/helper'


const PricingNew = () => {

    const [activeTab, setActiveTab] = useState({});
    console.log(activeTab);
    const navigate = useNavigate();
    const [pricingPlans, setPricingPlans] = useState([]);

    const featureFields = [
        { field: "dashboard", label: "Dashboard" },
        { field: "membercheckin", label: "Member Check-In" },
        { field: "checkinreports", label: "Check-In Reports" },
        { field: "memebershipplans", label: "Membership Plans" },
        { field: "addons", label: "Addons" },
        // { field: "timeslots", label: "Time Slots" },
        { field: "planswithsessionslimit", label: "Plans With Sessions Limit" },
        { field: "adminlogin", label: "Admin Login" },
        { field: "stafflogin", label: "Add Staff" },
        { field: "discountplans", label: "Discount Plans" },
        { field: "emailreceipt", label: "Email Receipt" },
        { field: "digitalwaiver", label: "Digital Waiver" },
        // { field: "pos", label: "POS" },
        // { field: "gstreceipts", label: "GST Receipt" },
        { field: "trainersessionssummary", label: "Trainer Sessions Summary" },
        { field: "loginwithgoogleaccount", label: "Login With Google Account" },
        { field: "paymentsummary", label: "Payment Summary Report" },
        { field: "plansummary", label: "Plan Summary Report" },
        { field: "sessionsummary", label: "Session Summary Report" },
        { field: "sessioncount", label: "Session Report" },
        { field: "revenuereport", label: "Revenue Report" },
        { field: "activememberhistory", label: "Active Member History Reports" },
        { field: "editmembership", label: "Edit Membership" },
        { field: "qrcheckin", label: "QR Check-In" },
        // { field: "sessionsharing", label: "Session Sharing" },
        { field: "subdomain", label: "Custom Subdomain" },
        { field: "uploadlogo", label: "Upload Profile Photo" },
        { field: "smsintergration", label: "SMS Integration" },
        { field: "accountantrole", label: "Accountant Role" },
        { field: "whatsappintegration", label: "WhatsApp Integration" },
    ];

    const limitFields = [
        { field: "activemembers", label: "Active Members" },
        { field: "addons", label: "Addons" },
        { field: "adminlogin", label: "Admin Logins" },
        { field: "memebershipplans", label: "Membership Plans" },
        { field: "stafflogin", label: "Staff Logins" },
        // { field: "timeslots", label: "Time Slots" },
        { field: "transactions", label: "Transactions (Monthly)" },
        { field: "classbook", label: "Class Booking (Monthly)" },

    ];

    useEffect(() => {
        const fetchPlans = async () => {
            try {
                const response = await getAllPricingPlans("1");
                if (!response || response == 'false') {
                    return;
                }
                const data = await response.json();
                console.log(data)
                setPricingPlans(data);
            } catch (error) {
                console.error("Error fetching pricing plans:", error);
            }
        };

        fetchPlans();
    }, []);

    const buynowHandler = (e, plan) => {
        let value = 0;
        e.preventDefault();
        if (activeTab[plan._id] == 1) {
            value = 1;
        }
        navigate(`/billingmanagementplans?id=${plan._id}&value=${value}&show=0`);
    }
    const freeTrailHandler = (e, plan) => {
        e.preventDefault();
        navigate(`/freesignup?id=${plan._id}`);
    }
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const [currentStep, setCurrentStep] = useState(1);
    // const [basicModal, setBasicModal] = useState((localStorage.getItem("loggedUserInfo") || sessionStorage.getItem("vistorinfo")) ? false : true);
    const [basicModal, setBasicModal] = useState(false);

    const [alerttxt, setAlerttxt] = useState("")
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        mobile: '',
        email: '',
        businessName: '',
        businessType: '',
        location: '',
        businessStage: ''
    });

    const [errors, setErrors] = useState({});

    const toggleOpen = () => setBasicModal(!basicModal);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const validateStep1 = () => {
        let tempErrors = {};
        if (!formData.firstName.trim()) {
            tempErrors.firstName = 'First name is required';
        }


        if (!formData.lastName.trim()) {
            tempErrors.lastName = 'Last name is required';
        }

        if (!formData.mobile.trim()) {
            tempErrors.mobile = 'Mobile number is required';
        }
        if (!formData.email.trim()) {
            tempErrors.email = 'Email is required';
        } else if (!isEmail(formData.email)) {
            tempErrors.email = "Enter Valid Email Address";
        }

        if (!formData.businessName.trim()) {
            tempErrors.businessName = 'Business name is required';
        }

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const validateStep2 = () => {
        let tempErrors = {};
        if (!formData.businessType.trim()) tempErrors.businessType = 'Business type is required';
        if (!formData.location.trim()) tempErrors.location = 'Location is required';
        if (!formData.businessStage.trim()) tempErrors.businessStage = 'Business stage is required';
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const nextStep = () => {
        if (validateStep1()) {
            setCurrentStep(2);
        }
    };

    const handleSubmit = async () => {
        if (validateStep2()) {
            console.log('Sending to backend:', formData);
            const update = {
                fname: formData.firstName,
                lname: formData.lastName,
                number: formData.mobile,
                email: formData.email,
                bussname: formData.businessName,
                busstype: formData.businessType,
                location: formData.location,
                bussstage: formData.businessStage
            }
            const res = await CreateVistorInfo(update)
            setAlerttxt("Form has been submitted successfully!")
            sessionStorage.setItem("vistorinfo", update)
            setBasicModal(false);

        }
    };
    console.log(basicModal, 'basicModal');
    const handleralert = () => {
        setAlerttxt("")
    }
    useEffect(() => {
        const initTabs = {};
        pricingPlans.forEach(p => {
            initTabs[p._id] = 0;
        });
        setActiveTab(initTabs);
    }, [pricingPlans]);
    return (
        <>
            <NavigationBar from='pricing' classText="blue-logo" />
            <MDBContainer className='py-5 hp'>
                <MDBRow className='justify-content-evenly'>
                    <MDBCol size='12' className='mb-5'>
                        <h2 className='mb-3'>Easymembr Commercials</h2>
                        <p>
                            What sets EasyMembr apart from all other gym & fitness membership management software in India? ALL exclusive features are included in every plan, regardless of duration. <b> That's right – whether you choose our annual plan or two year plan, you can access the same exceptional software features and benefits.</b>
                        </p>

                        <p>
                            So why wait? Choose the plan that fits your needs and start
                            enjoying the full power of Zencruz today!
                        </p>
                        {/* <p>
                            All pricing plans include full access to Easymembr’s complete feature set. Whether opting for a 1-year or 2-year subscription, all users receive the same functionality, tools, and platform benefits.
                        </p>

                        <p>
                            Plans are designed to support scalability, operational efficiency, and seamless member engagement from day one.
                        </p>

                        <p>
                            Choose a duration that aligns with your business needs and activate full platform access instantly.
                        </p> */}
                    </MDBCol>

                    {/* <div className='d-flex'> */}
                    {pricingPlans.length > 0 &&
                        pricingPlans.map((obj, index) => (

                            <MDBCol size='12' md='4' className='mb-5 d-flex flex-column' key={obj.name}>
                                <div className='lp_price-header'>
                                    <h2>{obj.name}</h2>
                                    {obj.billingperiod.filter((ojt) => ojt.entity == true)?.length > 0 && <div class="ribbon">
                                        <span class="ribbon1"><span>Free</span></span>
                                    </div>}
                                </div>
                                <div className='lp_price-body'>
                                    <div className='d-flex flex-column h-100'>

                                        {/* Features Section */}
                                        <ul className="list-group list-group-light list-group-smal flex-1">
                                            <h5 className="lp_pricetag fw-bold mb-2">
                                                <i className="fas fa-hand-holding-heart"></i> Features
                                            </h5>
                                            {featureFields.sort((a, b) => {
                                                return a.label.localeCompare(b.label);
                                            })
                                                .filter(({ field }) => {
                                                    const currentValue = obj.feature?.[field];
                                                    const prevValue = index > 0 ? pricingPlans[index - 1].feature?.[field] : false;
                                                    return currentValue && !prevValue;
                                                })
                                                .map(({ field, label }) => (
                                                    <li className="list-group-item" key={field}>
                                                        <i className="fas fa-check-circle me-2"></i> {label}
                                                    </li>
                                                ))}
                                        </ul>

                                        {/* Limitations Section */}
                                        <ul className="list-group list-group-light list-group-small mb-4">
                                            <h5 className="lp_pricetag fw-bold mb-2 py-3">
                                                <i className="fas fa-cart-plus"></i> Limitations
                                            </h5>
                                            {limitFields
                                                .sort((a, b) => {
                                                    return a.label.localeCompare(b.label);
                                                })
                                                .filter(({ field }) => obj.limitation?.[field] !== undefined && obj.limitation?.[field] !== null)
                                                .map(({ field, label }) => (
                                                    <li className="list-group-item" key={field}>
                                                        <i className="fas fa-check-circle me-2"></i>
                                                        {obj.limitation[field] === -1 ? "Unlimited" : obj.limitation[field]} {label}
                                                    </li>
                                                ))}
                                        </ul>
                                    </div>


                                    <div className='lp_price-panel my-2'>

                                        <div className="d-flex w-100 mb-3">
                                            <div className="tab-slider--nav">
                                                {obj.billingperiod.filter((ojt) => ojt.entity == true)?.length > 0 ?
                                                    <div className='free_ribbon'>
                                                        <label > <i class="fas fa-medal"></i>Life time Free</label>
                                                    </div>
                                                    :
                                                    <ul className={`tab-slider--tabs d-flex align-items-center ${obj.billingperiod.length === 1 ? "single-tab" : activeTab[obj._id] ? "slide" : ""}`}>
                                                        {obj.billingperiod.map((bp, i) => (
                                                            <li
                                                                key={i}
                                                                className={`tab-slider--trigger ${bp.entity ? "free-tab" : activeTab[obj._id] === i ? "active" : ""}`}
                                                                onClick={() => setActiveTab({ ...activeTab, [obj._id]: i })}
                                                            >
                                                                {bp.entity ? "Free" : `${bp.duration} Months`}
                                                            </li>
                                                        ))}
                                                    </ul>}
                                            </div>
                                        </div>

                                        {obj.billingperiod.map((bp, i) => (
                                            activeTab[obj._id] === i && !bp.entity && (
                                                <div key={i}>
                                                    <div className='lp_price-cost'>
                                                        {i > 0 && (
                                                            <del className='disct-price'> (₹{obj.billingperiod[0]?.montly})</del>
                                                        )}
                                                        <span className='position-relative'>
                                                            <span className='rupess-text'>₹</span>
                                                            <b>{bp.montly % 1 === 0 ? bp.montly : bp.montly.toFixed(0)}/-</b>
                                                        </span>
                                                    </div>
                                                    <p className='m-0 text-center lp_price-tag'>per License per Month</p>
                                                    <p className='lp_price-offer text-center mb-2'>
                                                        {bp.duration === 12 ? '(Billed Annually)' :
                                                            bp.duration === 24 ? '(Billed Biennially)' :
                                                                `(Billed for ${bp.duration} Month(s))`}
                                                    </p>
                                                </div>
                                            )
                                        ))}
                                    </div>
                                    <div className='d-flex'>
                                        {obj.billingperiod.filter((obj) => !obj.entity)?.length > 0 && <button className='mb-3 lp_btn lp_btnsm lp_outlinbtn me-2' color='primary' onClick={(e) => freeTrailHandler(e, obj)}>
                                            30 Days Free Trial
                                        </button>}
                                        <button className='mb-3 lp_btn lp_btnsm lp_fillbtn' color='primary' onClick={(e) => buynowHandler(e, obj)}>
                                            Start Managing
                                        </button>
                                    </div>

                                </div>
                            </MDBCol>
                        ))}
                    {/* <span><b> Note:</b> All the prices mentioned are monthly rates, but your billing will depend on the plan you select—annually or biennially. If you're looking for a customized package that includes features from both platforms, please <a href='/contact-new' className='ps-0'>click here.</a></span> */}
                    {/* </div> */}


                    <MDBCol size='12 '>
                        <MDBRow >
                            <MDBCol size='12 my-4' md='3' className='d-block d-md-flex'>
                                <div className='border text-center p-4 rounded-8 lp_addtion-card'>
                                    <h2>   <i class="bi bi-app-indicator"></i> Flexibility </h2>
                                    <p className='m-0'>
                                        Duration that best suits your needs
                                    </p>
                                </div>
                            </MDBCol>

                            <MDBCol size='12 my-4' md='3' className='d-block d-md-flex'>
                                <div className='border text-center p-4 rounded-8 lp_addtion-card'>
                                    <h2>  <i class="bi bi-currency-rupee"></i>Cost-Effectiveness </h2>
                                    <p className='m-0'>
                                        Extended plans offer discounted rates
                                    </p>
                                </div>
                            </MDBCol>
                            <MDBCol size='12 my-4' md='3' className='d-block d-md-flex'>
                                <div className='border text-center p-4 rounded-8 lp_addtion-card'>
                                    <h2>  <i class="bi bi-feather"></i>   Access to All Features</h2>
                                    <p className='m-0'>
                                        All exclusive features regardless of the plan
                                    </p>
                                </div>
                            </MDBCol>
                            <MDBCol size='12 my-4' md='3' className='d-block d-md-flex'>
                                <div className='border text-center p-4 rounded-8 lp_addtion-card'>
                                    <h2>   <i class="bi bi-back "></i>  Convenience</h2>
                                    <p className='m-0'>
                                        Plans with duration simplify billing & administration
                                    </p>
                                </div>
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>

                    {/* <MDBCol size='12' className='my-4'>
                        <div className='card shadow-0 border text-center lp_unlock-content'>
                            <div class="card-body lp_free-trial">
                                <h3 className='mb-3 fw-bold'>Unlock Your Studio’s Potential By Trying It For Free </h3>
                                <a href="#"> SignUp for FREE Trial!</a>
                                <div className='lp_free-trial-more my-3'>
                                    <span className='bi bi-patch-check-fill'> No Card Required</span>
                                    <span className='bi bi-patch-check-fill'> Cancel Anytime</span>
                                    <span className='bi bi-patch-check-fill'> Affordable Pricing</span>
                                </div>
                            </div>

                        </div>

                    </MDBCol> */}


                </MDBRow>
            </MDBContainer>


            <div className="section-grey">
                <ContactUs />
            </div>



            <div className="section-white">
                <RelatedProducts />
            </div>



            <LandingFooter />


            <MDBModal staticBackdrop open={basicModal} onClose={() => setBasicModal(false)} tabIndex='-1'>
                <MDBModalDialog>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Tell EasyMembr About Your Business</MDBModalTitle>
                        </MDBModalHeader>

                        <MDBModalBody>
                            {currentStep === 1 && (
                                <MDBRow>
                                    <MDBCol sm={12} md="6">
                                        <div className="mb-3">
                                            <label className="form-label mb-0">First Name</label>
                                            <input
                                                type="text"
                                                name="firstName"
                                                className={`form-control form-control-lg ${errors.firstName && 'is-invalid'}`}
                                                placeholder='First Name'
                                                value={formData.firstName}
                                                onChange={handleChange}
                                            />
                                            {errors.firstName && <div className="text-danger">{errors.firstName}</div>}
                                        </div>
                                    </MDBCol>
                                    <MDBCol sm={12} md="6">
                                        <div className="mb-3">
                                            <label className="form-label mb-0">Last Name</label>
                                            <input
                                                type="text"
                                                name="lastName"
                                                className={`form-control form-control-lg ${errors.lastName && 'is-invalid'}`}
                                                placeholder='Last Name'
                                                value={formData.lastName}
                                                onChange={handleChange}
                                            />
                                            {errors.lastName && <div className="text-danger">{errors.lastName}</div>}
                                        </div>
                                    </MDBCol>
                                    <MDBCol sm={12} md="6">
                                        <div className="mb-3">
                                            <label className="form-label mb-0">Mobile Number</label>
                                            <input
                                                type="number"
                                                name="mobile"
                                                className={`form-control form-control-lg ${errors.mobile && 'is-invalid'}`}
                                                placeholder='Mobile Number'
                                                value={formData.mobile}
                                                onChange={handleChange}
                                            />
                                            {errors.mobile && <div className="text-danger">{errors.mobile}</div>}
                                        </div>
                                    </MDBCol>
                                    <MDBCol sm={12} md="6">
                                        <div className="mb-3">
                                            <label className="form-label mb-0">Email Id</label>
                                            <input
                                                type="email"
                                                name="email"
                                                className={`form-control form-control-lg ${errors.email && 'is-invalid'}`}
                                                placeholder='Email Id'
                                                value={formData.email}
                                                onChange={handleChange}
                                            />
                                            {errors.email && <div className="text-danger">{errors.email}</div>}
                                        </div>
                                    </MDBCol>
                                    <MDBCol sm={12}>
                                        <div>
                                            <label className="form-label mb-0">Business Name</label>
                                            <input
                                                type="text"
                                                name="businessName"
                                                className={`form-control form-control-lg ${errors.businessName && 'is-invalid'}`}
                                                placeholder='Business Name'
                                                value={formData.businessName}
                                                onChange={handleChange}
                                            />
                                            {errors.businessName && <div className="text-danger">{errors.businessName}</div>}
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            )}

                            {currentStep === 2 && (
                                <MDBRow>
                                    <MDBCol sm={12}>
                                        <div className="mb-3">
                                            <label className="form-label mb-0">Business Type</label>
                                            <select
                                                name="businessType"
                                                className={`form-select ${errors.businessType && 'is-invalid'}`}
                                                value={formData.businessType}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select type</option>
                                                <option value="Gym">Gym</option>
                                                <option value="Fitness Center">Fitness Center</option>
                                                <option value="Yoga">Yoga</option>
                                                <option value="Swimming Pool">Swimming Pool</option>
                                                <option value="Dance">Dance</option>
                                                <option value="Sports">Sports</option>
                                            </select>
                                            {errors.businessType && <div className="text-danger">{errors.businessType}</div>}
                                        </div>
                                    </MDBCol>

                                    <MDBCol sm={12}>
                                        <div className="mb-3">
                                            <label className="form-label mb-0">Location</label>
                                            <input
                                                type="text"
                                                name="location"
                                                className={`form-control form-control-lg ${errors.location && 'is-invalid'}`}
                                                placeholder='Ex:- Hyderabad, Mumbai'
                                                value={formData.location}
                                                onChange={handleChange}
                                            />
                                            {errors.location && <div className="text-danger">{errors.location}</div>}
                                        </div>
                                    </MDBCol>

                                    <MDBCol sm={12}>
                                        <div className='form-group'>
                                            <label htmlFor="businessStage">Business Stage</label>
                                            <select
                                                className={`form-select ${errors.businessType && 'is-invalid'}`}
                                                id="businessStage"
                                                name="businessStage"
                                                value={formData.businessStage}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select Business Stage</option>
                                                {["New Location", "Single Location", "Multiple Location"].map((label, idx) => (
                                                    <option key={idx} value={label}>
                                                        {label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        {errors.businessStage && <div className="text-danger">{errors.businessStage}</div>}
                                    </MDBCol>
                                </MDBRow>
                            )}
                        </MDBModalBody>

                        <MDBModalFooter className='p-2 px-4 d-flex justify-content-between'>
                            <MDBBtn size='lg' color='secondary' onClick={() => setCurrentStep(1)} disabled={currentStep === 1}>
                                <i className="fas fa-chevron-left me-2"></i> Previous
                            </MDBBtn>
                            {currentStep === 1 ? (
                                <MDBBtn size='lg' color='secondary' onClick={nextStep}>
                                    Next <i className="fas fa-chevron-right ms-2"></i>
                                </MDBBtn>
                            ) : (
                                <MDBBtn type='button' color='primary' onClick={handleSubmit}>
                                    Submit
                                </MDBBtn>
                            )}
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            <MDBAlert
                color={"success"}
                autohide
                position='top-right'
                delay={5000}
                appendToBody
                open={alerttxt != ""}
                onClose={handleralert}
            >
                {alerttxt}
            </MDBAlert>
        </>
    )
}

export default PricingNew
